import { useEffect } from 'react';

/**
 * Sprite sheet layout (112×96px, 16×32px per frame):
 *   Row 0 (y=0):   Down  — frames 0-6
 *   Row 1 (y=32):  Up    — frames 0-6
 *   Row 2 (y=64):  Right — frames 0-6 (mirror for left)
 *
 * Walk  frames: 0,1,2,1
 * Type  frames: 3,4
 */

const FRAME_W = 16;
const FRAME_H = 32;
const WALK_X = [0, -FRAME_W, -FRAME_W * 2, -FRAME_W];
const TYPE_X = [-FRAME_W * 3, -FRAME_W * 4];

const ROW_Y = { down: 0, up: -FRAME_H, right: -FRAME_H * 2, left: -FRAME_H * 2 };

const PixelAgent = ({ charIndex = 0, mode = 'walk', scale = 2, direction = 'down' }) => {
  const w = FRAME_W * scale;
  const h = FRAME_H * scale;
  const sheetW = 112 * scale;
  const sheetH = 96 * scale;
  const rowY = ROW_Y[direction] ?? 0;

  useEffect(() => {
    const id = `pixel-agent-css-${scale}-${direction}`;
    if (!document.getElementById(id)) {
      const s = document.createElement('style');
      s.id = id;
      s.textContent = `
        @keyframes pixel-walk-${scale}-${direction} {
          0%   { background-position: ${WALK_X[0] * scale}px ${rowY * scale}px; }
          25%  { background-position: ${WALK_X[1] * scale}px ${rowY * scale}px; }
          50%  { background-position: ${WALK_X[2] * scale}px ${rowY * scale}px; }
          75%  { background-position: ${WALK_X[3] * scale}px ${rowY * scale}px; }
          100% { background-position: ${WALK_X[0] * scale}px ${rowY * scale}px; }
        }
        @keyframes pixel-type-${scale} {
          0%   { background-position: ${TYPE_X[0] * scale}px 0px; }
          50%  { background-position: ${TYPE_X[1] * scale}px 0px; }
          100% { background-position: ${TYPE_X[0] * scale}px 0px; }
        }
      `;
      document.head.appendChild(s);
    }
  }, [scale, direction, rowY]);

  let animation = 'none';
  let bgPos = `${WALK_X[1] * scale}px ${rowY * scale}px`;

  if (mode === 'walk') {
    animation = `pixel-walk-${scale}-${direction} 0.5s steps(1) infinite`;
    bgPos = `${WALK_X[0] * scale}px ${rowY * scale}px`;
  } else if (mode === 'type') {
    animation = `pixel-type-${scale} 0.4s steps(1) infinite`;
    bgPos = `${TYPE_X[0] * scale}px 0px`;
  }

  return (
    <div
      style={{
        width: w,
        height: h,
        backgroundImage: `url(/characters/char_${charIndex}.png)`,
        backgroundSize: `${sheetW}px ${sheetH}px`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: bgPos,
        imageRendering: 'pixelated',
        animation,
        flexShrink: 0,
        transform: direction === 'left' ? 'scaleX(-1)' : 'none',
      }}
    />
  );
};

export default PixelAgent;
